import { defineMessages } from 'react-intl';

const messages = defineMessages({
  undergraduateWomen: {
    id: 'premium-menu.student.life.undergraduateWomen',
    defaultMessage: 'Undergraduate Women',
  },
  undergraduateMen: {
    id: 'premium-menu.student.life.undergraduateMen',
    defaultMessage: 'Undergraduate Men',
  },
  graduateWomen: {
    id: 'premium-menu.student.life.graduateWomen',
    defaultMessage: 'Graduate Women',
  },
  graduateMen: {
    id: 'premium-menu.student.life.graduateMen',
    defaultMessage: 'Graduate Men',
  },
  city: {
    id: 'premium-menu.student.life.city',
    defaultMessage: 'Nearest City',
  },
  distance: {
    id: 'premium-menu.student.life.distance',
    defaultMessage: 'Distance to Nearest City',
  },
  africanAmerican: {
    id: 'premium-menu.student.life.africanAmerican',
    defaultMessage: '% African American',
  },
  africanHispanic: {
    id: 'premium-menu.student.life.africanHispanic',
    defaultMessage: '% Hispanic',
  },
  nativePacificIslander: {
    id: 'premium-menu.student.life.nativePacificIslander',
    defaultMessage: '% Native Pacific Islander',
  },
  twoOrMoreRaces: {
    id: 'premium-menu.student.life.twoOrMoreRaces',
    defaultMessage: '% Two Or More Races',
  },
  caucasian: {
    id: 'premium-menu.student.life.caucasian',
    defaultMessage: '% Caucasian',
  },
  asian: {
    id: 'premium-menu.student.life.asian',
    defaultMessage: '% Asian',
  },
  nativeAmerican: {
    id: 'premium-menu.student.life.nativeAmerican',
    defaultMessage: '% Native American',
  },
  nativeUnknown: {
    id: 'premium-menu.student.life.nativeUnknown',
    defaultMessage: '% Unknown',
  },
  nonResidentAlien: {
    id: 'premium-menu.student.life.nonResidentAlien',
    defaultMessage: '% Non-resident Alien (not displayed in chart)',
  },
  international: {
    id: 'premium-menu.student.life.international',
    defaultMessage: '% International (not displayed in chart)',
  },
  ageData: {
    id: 'premium-menu.student.life.ageData',
    defaultMessage: '% Students 24 Years Old',
  },
  fraternities: {
    id: 'premium-menu.student.life.fraternities',
    defaultMessage: '# of Fraternities',
  },
  sororities: {
    id: 'premium-menu.student.life.sororities',
    defaultMessage: '# of Sororities',
  },
  campusHousingCapacity: {
    id: 'premium-menu.student.life.campusHousingCapacity',
    defaultMessage: 'Campus Housing Capacity',
  },
  liveOnCampus: {
    id: 'premium-menu.student.life.liveOnCampus',
    defaultMessage: '% Live on Campus',
  },
  freshmanMustLiveOnCampus: {
    id: 'premium-menu.student.life.freshmanMustLiveOnCampus',
    defaultMessage: 'Freshman must live on campus',
  },
  sophomoresMustLiveOnCampus: {
    id: 'premium-menu.student.life.sophomoresMustLiveOnCampus',
    defaultMessage: 'Sophomores must live on campus',
  },
  juniorsMustLiveOnCampus: {
    id: 'premium-menu.student.life.juniorsMustLiveOnCampus',
    defaultMessage: 'Juniors must live on campus',
  },
  seniorsMustLiveOnCampus: {
    id: 'premium-menu.student.life.seniorsMustLiveOnCampus',
    defaultMessage: 'Seniors must live on campus',
  },
  academicCareerCounseling: {
    id: 'premium-menu.student.life.academicCareerCounseling',
    defaultMessage: 'Academic/Career Counseling',
  },
  accommodationsForStudentsWithADHD: {
    id: 'premium-menu.student.life.accommodationsForStudentsWithADHD',
    defaultMessage: 'Accommodations for Students with ADHD',
  },
  assistanceForHearingImpaired: {
    id: 'premium-menu.student.life.assistanceForHearingImpaired',
    defaultMessage: ' Assistance for Hearing Impaired',
  },
  assistanceForMobilityImpaired: {
    id: 'premium-menu.student.life.assistanceForMobilityImpaired',
    defaultMessage: ' Assistance for Mobility Impaired',
  },
  assistanceForVisuallyImpaired: {
    id: 'premium-menu.student.life.assistanceForVisuallyImpaired',
    defaultMessage: 'Assistance for Visually Impaired',
  },
  bookOnTapeForRFBD: {
    id: 'premium-menu.student.life.bookOnTapeForRFBD',
    defaultMessage: 'Book on Tape for RFBD',
  },
  calculatorsAllowedInExams: {
    id: 'premium-menu.student.life.calculatorsAllowedInExams',
    defaultMessage: 'Calculators Allowed in Exams',
  },
  computersAllowedInExams: {
    id: 'premium-menu.student.life.computersAllowedInExams',
    defaultMessage: 'Computers Allowed in Exams',
  },
  dayCareServices: {
    id: 'premium-menu.student.life.dayCareServices',
    defaultMessage: ' Day Care Services',
  },
  dictionaryAllowedInExams: {
    id: 'premium-menu.student.life.dictionaryAllowedInExams',
    defaultMessage: 'Dictionary Allowed in Exams',
  },
  ESL: {
    id: 'premium-menu.student.life.ESL',
    defaultMessage: 'ESL (English as Second Language)',
  },
  healthServicesAvailable: {
    id: 'premium-menu.student.life.healthServicesAvailable',
    defaultMessage: 'Health Services Available',
  },
  internshipsWithPay: {
    id: 'premium-menu.student.life.internshipsWithPay',
    defaultMessage: 'Internships with Pay',
  },
  internshipsWithoutPay: {
    id: 'premium-menu.student.life.internshipsWithoutPay',
    defaultMessage: ' Internships without Pay',
  },
  jobPlacement: {
    id: 'premium-menu.student.life.jobPlacement',
    defaultMessage: 'Job Placement',
  },
  LDSpecialists: {
    id: 'premium-menu.student.life.LDSpecialists',
    defaultMessage: 'LD Specialists',
  },
  learningCenter: {
    id: 'premium-menu.student.life.learningCenter',
    defaultMessage: 'Learning Center',
  },
  libraryFacilities: {
    id: 'premium-menu.student.life.libraryFacilities',
    defaultMessage: 'Library Facilities',
  },
  peerTutors: {
    id: 'premium-menu.student.life.peerTutors',
    defaultMessage: 'Peer Tutors',
  },
  professionalTutors: {
    id: 'premium-menu.student.life.professionalTutors',
    defaultMessage: 'Professional Tutors',
  },
  readingMachine: {
    id: 'premium-menu.student.life.readingMachine',
    defaultMessage: 'Reading Machine',
  },
  remedialServices: {
    id: 'premium-menu.student.life.remedialServices',
    defaultMessage: ' Remedial Services',
  },
  spellcheckerAllowedInExam: {
    id: 'premium-menu.student.life.spellcheckerAllowedInExam',
    defaultMessage: 'Spellchecker Allowed in Exam',
  },
  studentEmployment: {
    id: 'premium-menu.student.life.studentEmployment',
    defaultMessage: 'Student Employment',
  },
  tapeRecordingInClass: {
    id: 'premium-menu.student.life.tapeRecordingInClass',
    defaultMessage: 'Tape Recording in Class',
  },
  tapingOfBooksNotFromRFBD: {
    id: 'premium-menu.student.life.tapingOfBooksNotFromRFBD',
    defaultMessage: 'Taping of Books not from RFBD',
  },
  veteran: {
    id: 'premium-menu.student.life.veteran',
    defaultMessage: 'Veteran',
  },
  aspergersAutismSupportServices: {
    id: 'premium-menu.student.life.aspergersAutismSupportServices',
    defaultMessage: 'Aspergers/Autism Support Services',
  },
  ROTCArmy: {
    id: 'premium-menu.student.life.ROTCArmy',
    defaultMessage: 'ROTC Army',
  },
  ROTCNavy: {
    id: 'premium-menu.student.life.ROTCNavy',
    defaultMessage: 'ROTC Navy',
  },
  ROTCAirforce: {
    id: 'premium-menu.student.life.ROTCAirforce',
    defaultMessage: 'ROTC Airforce',
  },
  ROTCServicepersonOpportunityCollege: {
    id: 'premium-menu.student.life.ROTCServicepersonOpportunityCollege',
    defaultMessage: 'ROTC Serviceperson Opportunity College',
  },
  numberOfMacsInComputerCenters: {
    id: 'premium-menu.student.life.numberOfMacsInComputerCenters',
    defaultMessage: '# of Macs in Computer Centers',
  },
  numberOfPCsInComputerCenters: {
    id: 'premium-menu.student.life.numberOfPCsInComputerCenters',
    defaultMessage: '# of PCs in Computer Centers',
  },
  numberOfMacsInDepartmentLabs: {
    id: 'premium-menu.student.life.numberOfMacsInDepartmentLabs',
    defaultMessage: '# of Macs in Department Labs',
  },
  numberOfPCsInDepartmentLabs: {
    id: 'premium-menu.student.life.numberOfPCsInDepartmentLabs',
    defaultMessage: '# of PCs in Department Labs',
  },
  numberOfMacsInLibraries: {
    id: 'premium-menu.student.life.numberOfMacsInLibraries',
    defaultMessage: '# of Macs in Libraries',
  },
  numberOfPCsInLibraries: {
    id: 'premium-menu.student.life.numberOfPCsInLibraries',
    defaultMessage: '# of PCs in Libraries',
  },
  numberOfMacsInStudentCenters: {
    id: 'premium-menu.student.life.numberOfMacsInStudentCenters',
    defaultMessage: '# of Macs in Student Centers',
  },
  numberOfPCsInStudentCenters: {
    id: 'premium-menu.student.life.numberOfPCsInStudentCenters',
    defaultMessage: '# of PCs in Student Centers',
  },
  numberOfMacsInResidences: {
    id: 'premium-menu.student.life.numberOfMacsInResidences',
    defaultMessage: '# of Macs in Residences',
  },
  numberOfPCsInResidences: {
    id: 'premium-menu.student.life.numberOfPCsInResidences',
    defaultMessage: '# of PCs in Residences',
  },
  numberOfMacsInOther: {
    id: 'premium-menu.student.life.numberOfMacsInOther',
    defaultMessage: '# of Macs in Other',
  },
  numberOfPCsInOther: {
    id: 'premium-menu.student.life.numberOfPCsInOther',
    defaultMessage: '# of PCs in Other',
  },
  internetAccessInLibrary: {
    id: 'premium-menu.student.life.internetAccessInLibrary',
    defaultMessage: 'Internet Access in Library',
  },
  wirelessInternetAccess: {
    id: 'premium-menu.student.life.wirelessInternetAccess',
    defaultMessage: 'Wireless Internet Access',
  },
  internetAccessOnCentralCampus: {
    id: 'premium-menu.student.life.internetAccessOnCentralCampus',
    defaultMessage: 'Internet Access on Central Campus',
  },
  internetAccessInResidenceHalls: {
    id: 'premium-menu.student.life.internetAccessInResidenceHalls',
    defaultMessage: 'Internet Access in Residence Halls',
  },
  computerRequired: {
    id: 'premium-menu.student.life.computerRequired',
    defaultMessage: 'Computer Required',
  },
  computerRequiredReason: {
    id: 'premium-menu.student.life.computerRequiredReason',
    defaultMessage: 'Computer Required Reason',
  },
  computerPurchaseOffered: {
    id: 'premium-menu.student.life.computerPurchaseOffered',
    defaultMessage: 'Computer Purchase Offered',
  },
  preferredComputerType: {
    id: 'premium-menu.student.life.preferredComputerType',
    defaultMessage: 'Preferred Computer Type',
  },
});

export default messages;
